<template>
  <div class="lang-wrap">
    <div class="icon-wrap">
      <div class="icon"></div>
      <div class="text">{{ localeMap[$i18n.locale] }}</div>
      <div class="icon_arr" :class="{ up: isShowLangTrans }"></div>
      <div class="click-wrap" @click.stop.prevent="switchLang" v-if="!isShowLangTrans"></div>
    </div>

    <transition name="pop-up">
      <div class="lang-list" v-if="isShowLangTrans" v-click-outside="switchLang">
        <div
          v-for="(lang, k) in localeMap"
          :key="k"
          class="lang-item"
          :class="{ active: k === $i18n.locale }"
          @click="toggleLang(k)"
        >
          {{ lang }}
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { localeMap } from '@/tool/constant'
import ClickOutside from 'vue-click-outside'
import { mapState } from 'vuex'
export default {
  name: 'TransLang',
  directives: {
    ClickOutside,
  },
  data() {
    return {
      isShowLangTrans: false,
      localeMap,
    }
  },
  computed: {
    ...mapState({
      acceptAll: (state) => state.app.acceptAll,
    }),
  },
  created() {
    this.$root.Bus.$on('headHideOther', (str) => {
      str !== 'isShowLangTrans' && (this.isShowLangTrans = false)
    })
  },
  methods: {
    switchLang(event) {
      event.stopPropagation()
      event.preventDefault()
      if (!this.isShowLangTrans) {
        this.$root.Bus.$emit('headHideOther', 'isShowLangTrans')
      }
      setTimeout(() => {
        this.isShowLangTrans = !this.isShowLangTrans
      }, 100)
    },
    toggleLang(langKey) {
      // 根据 cookie 权限，决定存储位置
      if (!this.acceptAll) {
        this.$utils.customSessionStorage.setItem('vipMallLangCode', langKey)
        this.$utils.customLocalStorage.removeItem('vipMallLangCode')
      } else {
        this.$utils.customLocalStorage.setItem('vipMallLangCode', langKey)
      }

      this.isShowLangTrans = false
      window.location.reload(true)
    },
  },
}
</script>

<style lang="less" scoped>
.lang-wrap {
  position: relative;
  margin: 0 4px;
  .icon-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    .click-wrap {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      cursor: pointer;
    }
    .icon {
      width: 30px;
      height: 30px;
      .bg-image('icon_lang');
    }
    &:active {
      .icon {
        opacity: 0.6;
      }
    }
    .text,
    .icon_arr {
      display: none;
    }
  }
  .lang-list {
    position: absolute;
    top: 41px;
    right: -4px;
    width: 160px;
    max-height: 420px;
    background-color: #ffffff;
    border-radius: 8px;
    overflow-y: auto;
    box-shadow:
      0px 12px 24px 0px rgba(0, 0, 0, 0.1),
      0px 6px 46px 0px rgba(0, 0, 0, 0.06);
    &::-webkit-scrollbar {
      display: none;
    }

    .lang-item {
      height: 40px;
      line-height: 40px;
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      color: rgba(52, 58, 63, 1);
      cursor: pointer;
      & + .lang-item {
        border-top: 1px solid rgba(221, 225, 230, 1);
      }
      &:hover,
      &.active {
        color: rgba(25, 176, 90, 1);
      }
    }
  }
}

// pc 端媒体查询
@media screen and (min-width: 1024px) {
  .lang-wrap {
    .icon-wrap {
      border: 1px solid #ffffff;
      border-radius: 12px;
      height: 28px;
      padding: 0 8px;
      .icon {
        width: 22px;
        height: 22px;
        .bg-image('icon_lang');
      }
      &:active {
        .icon {
          opacity: 1;
        }
      }
      .text {
        display: block;
        font-size: 13px;
        color: #ffffff;
        margin: 0 8px;
      }
      .icon_arr {
        display: block;
        width: 10px;
        height: 8px;
        .bg-image('icon_arr_down');
        &.up {
          transform: rotate(180deg);
        }
      }
    }
  }
}
</style>
